export class VectorNorm {
    constructor(_vec) {
        this._vec = _vec;
    }
    get euclidean() {
        return Math.hypot(...this._vec.components);
    }
}
